import styled from 'styled-components';
import { SingleSelectMenu } from '../../../../components/Dropdown';
import { InputField } from '../../../../components/Form';
import { theme } from '../../../../styles/theme';

export const DerivedColumnSelectRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: flex-start;
  margin-top: 12px;
`;

export const CustomDefinitionFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DerivedColumnButtonWrapper = styled.div`
  margin-top: 12px;
`;

export const DerivedColumnDraftFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  margin-top: 12px;
  border: 1px solid ${theme.colors.border};
`;

export const CustomTypeTimezoneWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  height: 28px;
`;

export const CustomColumnCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledFieldNameInput = styled(InputField)`
  width: 240px;
`;

export const StyledTypeSelectMenu = styled(SingleSelectMenu)`
  width: 120px;
`;

export const StyledDefinitionSelectMenu = styled(SingleSelectMenu)`
  width: 160px;
`;

export const RawSqlFieldRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const StyledRawSqlDefinitionInput = styled(InputField)`
  width: 500px;
  min-width: 500px;
`;

export const MappedStringRow = styled.div`
  display: grid;
  grid-template-columns: 230px 32px 230px 40px auto;
  gap: 4px;
  padding-bottom: 12px;
  align-items: center;
`;

export const DerivedColumnEditActionsWrapperDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: row;
  gap: 16px;
`;
